import React, { useState, useEffect } from 'react';

export const ComingSoon = () => {
  const [dots, setDots] = useState('');

  // Animated dots effect
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? '' : prev + '.'));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0f1a2e 0%, #1a2b4a 50%, #10b981 100%)',
        color: '#fff',
        padding: '40px 20px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Animated background circles */}
      <div
        style={{
          position: 'absolute',
          width: '400px',
          height: '400px',
          borderRadius: '50%',
          background: 'rgba(16, 185, 129, 0.1)',
          top: '-100px',
          right: '-100px',
          animation: 'pulse 4s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'rgba(16, 185, 129, 0.15)',
          bottom: '-50px',
          left: '-50px',
          animation: 'pulse 3s ease-in-out infinite',
        }}
      />

      {/* Content */}
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          maxWidth: '800px',
        }}
      >
        {/* Logo/Brand */}
        <div
          style={{
            marginBottom: '40px',
            animation: 'fadeIn 1s ease-in',
          }}
        >
          <h1
            style={{
              fontSize: '48px',
              fontWeight: 'bold',
              marginBottom: '10px',
              fontFamily: '"Open Sans", sans-serif',
              letterSpacing: '1px',
            }}
          >
            FullScope Services
          </h1>
          <div
            style={{
              width: '100px',
              height: '3px',
              background: '#10b981',
              margin: '0 auto',
            }}
          />
        </div>

        {/* Main Message */}
        <div
          style={{
            marginBottom: '50px',
            animation: 'fadeIn 1.5s ease-in',
          }}
        >
          <h2
            style={{
              fontSize: '36px',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#10b981',
            }}
          >
            Something Amazing is Coming{dots}
          </h2>
          <p
            style={{
              fontSize: '20px',
              color: '#cbd5e1',
              lineHeight: '1.6',
              marginBottom: '30px',
            }}
          >
            We're working on something special. Stay tuned for exciting updates.
          </p>
        </div>

        {/* Contact */}
        <div
          style={{
            animation: 'fadeIn 2s ease-in',
          }}
        >
          <p
            style={{
              fontSize: '16px',
              color: '#cbd5e1',
              marginBottom: '15px',
            }}
          >
            Have questions? Get in touch:
          </p>
          <a
            href="mailto:jerico@fullscopeservices.ca"
            style={{
              display: 'inline-block',
              padding: '15px 40px',
              background: '#10b981',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '18px',
              fontWeight: '600',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)',
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#059669';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#10b981';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
            }}
          >
            jerico@fullscopeservices.ca
          </a>
        </div>
      </div>

      {/* CSS Animations */}
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 0.3;
            }
            50% {
              transform: scale(1.1);
              opacity: 0.5;
            }
          }
        `}
      </style>
    </div>
  );
};
